const initialState = {
    isAddingVoucher: false,
    addVoucher: [],
    cashPayment: [],
    cashRecipet: [],
    bankPayment: [],
    bankRecipet: [],
    journal: [],
    isFetchingVoucherTypes: false,
    voucherTypeList: [],
    isFetchingSearchVoucher: false,
    searchVoucherList: [],
    isFetchingCreditDebit: false,
    creditDebitList: [],
};

const VouchersReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_ADD_VOUCHER":
            return { ...state, isAddingVoucher: true };
        case "SUCCESS_ADD_VOUCHER":
            return { ...state, addVoucher: action.payload, isAddingVoucher: false, };
        case "ERROR_ADD_VOUCHER":
            return { ...state };


        case "SUBMIT_CASH_PAYMENT":
            const { data } = action.payload;
            return { ...state, cashPayment: [...state.cashPayment, { data }] };
        case "DELETE_CASH_PAYMENT":
            return { ...state, cashPayment: state.cashPayment.filter((item) => item !== action.payload) };
        case "RESET_CASH_PAYMENT":
            return { ...state, cashPayment: [], addVoucher: [] };


        case "SUBMIT_CASH_RECEIPT":
            const { cashRecipetData } = action.payload;
            return { ...state, cashRecipet: [...state.cashRecipet, { cashRecipetData }] };
        case "DELETE_CASH_RECEIPT":
            return { ...state, cashRecipet: state.cashRecipet.filter((item) => item !== action.payload) };
        case "RESET_CASH_RECEIPT":
            return { ...state, cashRecipet: [], addVoucher: [] };


        case "SUBMIT_BANK_PAYMENT":
            const { bankPaymentData } = action.payload;
            return { ...state, bankPayment: [...state.bankPayment, { bankPaymentData }] };
        case "DELETE_BANK_PAYMENT":
            return { ...state, bankPayment: state.bankPayment.filter((item) => item !== action.payload) };
        case "RESET_BANK_PAYMENT":
            return { ...state, bankPayment: [], addVoucher: [] };


        case "SUBMIT_BANK_RECIPET":
            const { bankReceiptData } = action.payload;
            return { ...state, bankRecipet: [...state.bankRecipet, { bankReceiptData }] };
        case "DELETE_BANK_RECIPET":
            return { ...state, bankRecipet: state.bankRecipet.filter((item) => item !== action.payload) };
        case "RESET_BANK_RECIPET":
            return { ...state, bankRecipet: [], addVoucher: [] };


        case "SUBMIT_JOURNAL":
            const { journalData } = action.payload;
            return { ...state, journal: [...state.journal, { journalData }] };
        case "DELETE_JOURNAL":
            return { ...state, journal: state.journal.filter((item) => item !== action.payload) };
        case "RESET_JOURNAL":
            return { ...state, journal: [], addVoucher: [] };


        case "REQUEST_GET_VOUCHER_TYPES":
            return { ...state, isFetchingVoucherTypes: true };
        case "SUCCESS_GET_VOUCHER_TYPES":
            return { ...state, voucherTypeList: action.payload.data, isFetchingVoucherTypes: false };
        case "ERROR_GET_VOUCHER_TYPES":
            return { ...state, isFetchingVoucherTypes: false };


        case "REQUEST_SEARCH_VOUCHER":
            return { ...state, isFetchingSearchVoucher: true };
        case "SUCCESS_SEARCH_VOUCHER":
            return { ...state, searchVoucherList: action.payload.data, isFetchingSearchVoucher: false, };
        case "ERROR_SEARCH_VOUCHER":
            return { ...state, isFetchingSearchVoucher: false };


        case "REQUEST_CREDIT_DEBIT":
            return { ...state, isFetchingCreditDebit: true };
        case "SUCCESS_CREDIT_DEBIT":
            return { ...state, creditDebitList: action.payload.data, isFetchingCreditDebit: false };
        case "ERROR_CREDIT_DEBIT":
            return { ...state, isFetchingCreditDebit: false };


        default:
            return state;
    }
};
export default VouchersReducer;